import { render, staticRenderFns } from "./UserProfileEdit.vue?vue&type=template&id=2daae774&"
import script from "./UserProfileEdit.vue?vue&type=script&lang=js&"
export * from "./UserProfileEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports